import React, { useEffect } from "react";

const RedirectToWebsite = () => {
  useEffect(() => {
    window.location.replace(
      `https://casadosaber.com.br`
    );
  }, []);

  return <></>;
};

export default RedirectToWebsite;
